const token = localStorage.getItem('token');
export const baseUrl = process.env.REACT_APP_BACKEND_API;

export const config = {
    headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
}